import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthSelectors } from '../store/auth/auth.selectors';
import { AuthService } from '@auth0/auth0-angular';

@Injectable({ providedIn: 'root' })
export class Auth0Guard implements CanActivate {
  store = inject(Store);
  router = inject(Router);
  auth = inject(AuthService);

  canActivate() {
    const isAuthenticated = this.store.selectSnapshot(AuthSelectors.token);

    return isAuthenticated ? true : this.router.parseUrl('/auth/login');
  }
}
